export const BASE_URL = "https://bsg-tournament.bitflow.dev"
export const WS_BASE_URL = "wss://bsg-tournament.bitflow.dev"
//export const BASE_URL = "http://127.0.0.1:8787"
//export const WS_BASE_URL = "ws://127.0.0.1:8787"
